module.exports = __webpack_public_path__ + "img/login.abcafd87.png";